import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { UsersStore } from '@data-access/user/stores/users.store';

@Component({
  selector: 'app-dmca',
  imports: [
    MatButton,
    ReactiveFormsModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatIcon,
    MatInput,
    MatOption,
    MatCheckbox
  ],
  templateUrl: './dmca.html',
  styleUrl: './dmca.scss'
})
export class Dmca {
  private store = inject(UsersStore);

  types = [
    {value: 'owner', displayName: 'Owner of infringing content'},
    {value: 'authorized_agent', displayName: 'Authorized agent, duly appointed to submit this takedown notice on behalf of the rights holder.'},

  ]

  form = new FormGroup({

    userType: new FormControl({value: 'owner', displayName: 'Owner of infringing content'}, [Validators.required]),
    fullLegalName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    organization: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required, Validators.pattern('^[- +()0-9]+$')]),
    address: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', []),
    zipCode: new FormControl('', []),
    infringingUrls: new FormControl('', [Validators.required]),
    additionalDetails: new FormControl(''),
    agree1: new FormControl(false, [Validators.requiredTrue]),
    agree2: new FormControl(false, [Validators.requiredTrue]),
    agree3: new FormControl(false, [Validators.requiredTrue]),
    agree4: new FormControl(false, [Validators.requiredTrue]),

  });

  openPanel(trigger: MatAutocompleteTrigger): void {
    trigger.openPanel();
  }

  displayFn(item: {value: number; displayName: string}): string {
    return item?.displayName || '';
  }

  async send() {
    const res = await this.store.sendDMCA({
      userType: this.form.value.userType!.value,
      fullLegalName: this.form.value.fullLegalName!,
      email: this.form.value.email!,
      organization: this.form.value.organization!,
      phone: this.form.value.phone!,
      address: this.form.value.address!,
      country: this.form.value.country!,
      state: this.form.value.state || '',
      city: this.form.value.city!,
      zipCode: this.form.value.zipCode || '',
      infringingUrls: this.form.value.infringingUrls!,
      additionalDetails: this.form.value.additionalDetails || '',

    });

    if (res) {
      this.form.reset();
    }
  }
}
